
import remote_email from "./modal/remote-email-auth"
import email_sync from "./box/email_sync"
import box_switch from "./box/switch_sign_up_sign_in"
import modal_switch from "./modal/switch_sign_up_sign_in"

const onLoad = () => {
  remote_email.onLoad()
  email_sync.onLoad()
  box_switch.init()
  modal_switch.init()
}

export default {onLoad}
